import { render, staticRenderFns } from "./program_scheme_term.vue?vue&type=template&id=a858e40e&scoped=true"
import script from "./program_scheme_term.vue?vue&type=script&lang=js"
export * from "./program_scheme_term.vue?vue&type=script&lang=js"
import style0 from "./program_scheme_term.vue?vue&type=style&index=0&id=a858e40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a858e40e",
  null
  
)

export default component.exports